import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Admin from "./pages/administracao/Admin";
import GerenciarItens from "./pages/administracao/itens/GerenciarItens";
import Item from "./pages/administracao/itens/Item";
import Inventario from "./pages/administracao/inventario/Inventario";
import GerenciarInventarios from "./pages/administracao/inventario/GerenciarInventarios";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import GerenciarUsuario from "./pages/administracao/usuario/GerenciarUsuario";
import Usuario from "./pages/administracao/usuario/Usuario";
import GerenciarSinonimos from "./pages/administracao/termo/GerenciarTermos";
import GerenciarCategorias from "./pages/administracao/categoria/GerenciarCategorias";
import Categoria from "./pages/administracao/categoria/Categoria";
import GerenciarExemplos from "./pages/administracao/exemplo/GerenciarExemplos";
import Exemplo from "./pages/administracao/exemplo/Exemplo";
import Localizacao from "./pages/administracao/localizacao/Localizacao";
import GerenciarLocalizacao from "./pages/administracao/localizacao/GerenciarLocalizacao";
import Senha from "./pages/administracao/usuario/Senha";
import BuscarItem from "./pages/visitante/acervo/itens/BuscarItem";
import ItemAcervo from "./pages/visitante/acervo/itens/Item";
import GerenciarTermos from "./pages/administracao/termo/GerenciarTermos"
import Termo from "./pages/administracao/termo/Termo"
import Acervo from "./pages/visitante/Acervo";
import Email from "./pages/administracao/Email"
import RecuperarSenha from "./pages/administracao/RecuperarSenha"
import Creditos from "./pages/visitante/creditos"
import BuscarIconografia from "./pages/visitante/acervo/iconografia/BuscarIconografia";
import IconografiaDetalhe from "./pages/visitante/acervo/iconografia/IconografiaDetalhe";

// Páginas de Administração - Iconográfico (NOVAS)
import GerenciarFotografias from './pages/administracao/iconografico/GerenciarFotografias';
import Fotografia from './pages/administracao/iconografico/Fotografia';
import GerenciarAutores from "./pages/administracao/iconografico/autores/GerenciarAutores";
import Autor from "./pages/administracao/iconografico/autores/Autor";
import GerenciarAcervos from "./pages/administracao/iconografico/acervos/GerenciarAcervos";
import AcervoDetentor from "./pages/administracao/iconografico/acervos/AcervoDetentor";
import GerenciarDireitos from "./pages/administracao/iconografico/direitos/GerenciarDireitos";
import Direito from "./pages/administracao/iconografico/direitos/Direito";
import GerenciarEventos from "./pages/administracao/iconografico/eventos/GerenciarEventos";
import Evento from "./pages/administracao/iconografico/eventos/Evento";
import GerenciarPessoas from "./pages/administracao/iconografico/pessoas/GerenciarPessoas";
import Pessoa from "./pages/administracao/iconografico/pessoas/Pessoa";
import GerenciarCategoriasIconograficas from "./pages/administracao/iconografico/categorias/GerenciarCategorias";
import CategoriaIconograficas from "./pages/administracao/iconografico/categorias/Categoria";
import GerenciarSubcategorias from "./pages/administracao/iconografico/categorias/GerenciarSubcategorias";
import Subcategoria from "./pages/administracao/iconografico/categorias/Subcategoria";
import GerenciarTermosIconograficos from "./pages/administracao/iconografico/termos/GerenciarTermos";
import TermoIconograficos from "./pages/administracao/iconografico/termos/Termo";
import GerenciarInventariosIconografia from "./pages/administracao/iconografico/inventario/GerenciarInventariosIconografia";
import InventarioIconografia from "./pages/administracao/iconografico/inventario/InventarioIconografia";
import AutorDetalhe from "./pages/visitante/acervo/iconografia/AutorDetalhe";
import PessoaDetalhe from "./pages/visitante/acervo/iconografia/PessoaDetalhe";
import EventoDetalhe from "./pages/visitante/acervo/iconografia/EventoDetalhe";

//https://stackoverflow.com/questions/71598892/how-to-route-parent-to-child-component-in-react-router-dom

export default function App() {
    return (
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/email" element={<Email />} />
            <Route path="/recuperarsenha/:token" element={<RecuperarSenha />} />

            {/* Rotas de Visitante (dentro da HomePage que contém o Navbar) */}
            <Route path="/" element={<HomePage />}>
              <Route path="/" element={<Acervo />} />

              {/* Acervo de Equipamentos */}
              <Route path="/acervo" element={<BuscarItem />} />
              <Route path="/acervo/item/:id" element={<ItemAcervo />} />

              {/* Acervo Iconográfico */}
              <Route path="/acervo-iconografico" element={<BuscarIconografia />} />
              <Route path="/acervo/iconografia/:id" element={<IconografiaDetalhe />} />
              <Route path="/acervo/autor/:id" element={<AutorDetalhe />} />
              <Route path="/acervo/evento/:id" element={<EventoDetalhe />} />
              <Route path="/acervo/pessoa/:id" element={<PessoaDetalhe />} />
              
              <Route path="/creditos" element={<Creditos />} />
            </Route>

            {/* Rotas de Administração */}
            <Route path="/admin" element={<Admin />}>
              <Route path="/admin" element={<GerenciarItens />} />
              <Route path="/admin/itens" element={<GerenciarItens />} />
              <Route path="/admin/sinonimos" element={<GerenciarSinonimos />} />
              <Route path="/admin/itens/:id" element={<Item />} />
              <Route path="/admin/exemplos" element={<GerenciarExemplos />} />
              <Route path="/admin/exemplos/:id" element={<Exemplo />} />
              <Route path="/admin/categorias" element={<GerenciarCategorias />} />
              <Route path="/admin/categorias/:id" element={<Categoria />} />
              <Route path="/admin/localizacoes" element={<GerenciarLocalizacao />} />
              <Route path="/admin/localizacoes/:id" element={<Localizacao />} />
              <Route path="/admin/usuarios" element={<GerenciarUsuario />} />
              <Route path="/admin/usuarios/:id" element={<Usuario />} />
              <Route path="/admin/senhas" element={<Senha />} />
              <Route path="/admin/inventarios" element={<GerenciarInventarios />} />
              <Route path="/admin/inventarios/:id/:sec" element={<Inventario />} />
              <Route path="/admin/termos" element={<GerenciarTermos />} />
              <Route path="/admin/termos/:id1/:id2" element={<Termo />} />

              {/* NOVAS ROTAS DO ICONOGRÁFICO */}
              <Route path="iconografico/fotografias" element={<GerenciarFotografias />} />
              <Route path="iconografico/fotografias/:id" element={<Fotografia />} />
              <Route path="iconografico/autores" element={<GerenciarAutores />} />
              <Route path="iconografico/autores/:id" element={<Autor />} />
              <Route path="iconografico/acervos" element={<GerenciarAcervos />} />
              <Route path="iconografico/acervos/:id" element={<AcervoDetentor />} />
              <Route path="iconografico/direitos" element={<GerenciarDireitos />} />
              <Route path="iconografico/direitos/:id" element={<Direito />} />
              <Route path="iconografico/eventos" element={<GerenciarEventos />} />
              <Route path="iconografico/eventos/:id" element={<Evento />} />
              <Route path="iconografico/pessoas" element={<GerenciarPessoas />} />
              <Route path="iconografico/pessoas/:id" element={<Pessoa />} />
              <Route path="iconografico/categorias" element={<GerenciarCategoriasIconograficas />} />
              <Route path="iconografico/categorias/:id" element={<CategoriaIconograficas />} />
              <Route path="iconografico/categorias/:id_cat/subcategorias" element={<GerenciarSubcategorias />} />
              <Route path="iconografico/categorias/:id_cat/subcategorias/:id" element={<Subcategoria />} />
              <Route path="iconografico/termos" element={<GerenciarTermosIconograficos />} />
              <Route path="iconografico/termos/:id1/:id2" element={<TermoIconograficos />} />
              <Route path="iconografico/inventarios" element={<GerenciarInventariosIconografia />} />
              <Route path="iconografico/inventarios/:id" element={<InventarioIconografia />} />
              
            </Route>
    
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      );
}